export default __webpack_public_path__ + "static/media/fridge1-before1-768w.1cb85d77.avif";